import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Feb 05 2019
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { LocalisationConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import { CRUTransportLayer } from '../../../shared/transportLayers/CRUTransportLayer';
export var DictionaryLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(DictionaryLayer, _CRUTransportLayer);

  function DictionaryLayer() {
    _classCallCheck(this, DictionaryLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(DictionaryLayer).call(this, CONSTANTS.API.ENDPOINTS.LOCALES));
  }

  _createClass(DictionaryLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }]);

  return DictionaryLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", LocalisationConverter)], DictionaryLayer.prototype, "converter", void 0);